import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateUserParams, User } from '../dal/user-dal'
import { updateUser } from '../dal/user-dal'
import { useResolvedAuthState } from '../hooks/useResolvedAuthState'
import { queryKeys } from '../queries/query-keys'
import { MissingAccessTokenError } from '../utils/auth-errors'

export function useUpdateUserMutation() {
  const queryClient = useQueryClient()
  const { authUserId, getAccessToken } = useResolvedAuthState()

  return useMutation<void, Error, UpdateUserParams>({
    mutationKey: queryKeys.mutations.updateUser,
    mutationFn: async (params) => {
      const token = await getAccessToken()
      if (token == null) {
        throw new MissingAccessTokenError()
      }
      return updateUser(params)
    },
    onSuccess: (_updatedUser, params) => {
      queryClient.setQueryData<User | null>(
        queryKeys.user.profile(authUserId),
        (user) => {
          if (user == null) {
            return user
          }

          return {
            ...user,
            email: params.email,
            firstName: params.firstName,
            voiceType: params.voiceType,
          }
        },
      )
    },
  })
}
